module.exports = __webpack_public_path__ + "static/media/chat.f1431c3d.png";